import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'

import dispatchEventStroage from './utils/watchLocalStorage.ts'
import router from './router'
import store from './store'
import './assets/css/reset.css'
Vue.use(dispatchEventStroage)

// import autofit from 'autofit.js'
// autofit.init()

if (process.env.NODE_ENV === 'development') {
  Vue.prototype.baseURL = 'http://wsjtoa.com:9989'
  // Vue.prototype.baseURL = 'http://172.16.72.7:9089'


} else if (process.env.NODE_ENV === 'production') {
  Vue.prototype.baseURL = 'http://wsjtoa.com:9989'
  // Vue.prototype.baseURL = 'http://172.16.72.7:9089'

}

Vue.config.productionTip = false
Vue.use(ElementUI)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
